export enum LocalizationLanguage {
	Czech = 'cs',
	English = 'en',
}
